import { DOUBLE } from "./numbers.consts.js";
export const THUMB_OPACITY = 0.54;
export const TRACK_OPACITY = 0.12;
export const THUMB_OPACITY_ON_HOVER = 0.8;
export const THUMB_BORDER_WIDTH_DEFAULT = 1;
export const THUMB_BORDER_WIDTH_COMPACT = 0.25;
export const SCROLLBAR_HEIGHT_DEFAULT = 4;
export const SCROLLBAR_WIDTH_DEFAULT = 4;
export const SCROLLBAR_WIDTH_COMPACT = 2;
export const SCROLLBAR_HEIGHT_COMPACT = 2;
export const compactScrollbarSx = (theme) => ({
    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
        background: "transparent",
        width: theme.spacing(SCROLLBAR_WIDTH_COMPACT),
        height: theme.spacing(SCROLLBAR_HEIGHT_COMPACT),
    },
    "&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track": {
        backgroundColor: theme.vars.palette.surface.container,
    },
    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
        border: `${DOUBLE}px solid ${theme.vars.palette.surface.container}`,
    },
});
